import { Skeleton } from "../../@/components/ui/skeleton";

const LiveClassesSkeleton = () => {
  // Show 3 skeleton cards as placeholder
  return (
    <div className="w-full max-w-5xl mx-auto flex flex-col gap-4">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="bg-(--surface-panel) border border-(--neutral-200) rounded-lg p-4 md:p-6 shadow-sm flex flex-col md:flex-row gap-4 md:gap-6 animate-pulse"
        >
          <div className="shrink-0 md:min-w-0 flex flex-col gap-2 w-40">
            <Skeleton className="h-6 w-24 mb-2" />
            <Skeleton className="h-4 w-20 mb-1" />
            <Skeleton className="h-4 w-28" />
          </div>
          <div className="hidden md:block border-l border-(--neutral-200) self-stretch"></div>
          <div className="block md:hidden border-t border-(--neutral-200) w-full"></div>
          <div className="flex-1 min-w-0 flex flex-col gap-3">
            <Skeleton className="h-6 w-2/3 mb-2" />
            <div className="flex gap-2 mb-2">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-32" />
            </div>
            <Skeleton className="h-10 w-40" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LiveClassesSkeleton;
